import { getRenderingEngines } from '@cornerstonejs/core';
import { utilities as csToolsUtilities } from '@cornerstonejs/tools';

/**
 * Repaint the annotation layer on every viewport across all rendering engines.
 *
 * Cornerstone annotations are stored per-FrameOfReferenceUID, not per-viewport.
 * After mutating annotation state (removing/adopting a drawing) we repaint all
 * panes so the change is reflected without having to thread the specific
 * viewport id through to the mutation site.
 */
export function triggerAllViewports(): void {
  const vpIds = (getRenderingEngines() ?? [])
    .flatMap((engine) => engine?.getViewports() ?? [])
    .map((vp) => vp.id);
  if (vpIds.length) {
    csToolsUtilities.triggerAnnotationRenderForViewportIds(vpIds);
  }
}
